export default "__VITE_ASSET__Zy4EpbT___"